import { out } from "@/lib/output/out";
import { readCatalogList } from "@/commands/catalog/read-catalog-list";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function listCatalogSkills(
  parsed: ParsedArgs,
  asJson: boolean,
): Promise<void> {
  const result = await readCatalogList<ApiOutputs["catalog"]["skills"]>(
    parsed,
    "/skills",
    "skills",
  );
  if (asJson) {
    out.json(result);
    return;
  }
  out.table(
    result.skills.map((skill) => [
      out.cell(skill.id),
      out.cell(skill.name),
      out.cell(skill.description ?? ""),
    ]),
  );
}
